export default __webpack_public_path__ + "static/media/selective-focus-photo-of-green-telephone-955081.ef7992ca.jpg";